module.exports = __webpack_public_path__ + "img/chinesecompany15.bbb61166.png";